import request from "@/utils/request";
export const queryPage = "/icps/system/sign/intelligent/handOverPlan/queryPage";
/*添加/修改交工订单*/
export function handOverPlansaveOrUpdate(data) {
  return request({
    url: "/icps/system/sign/intelligent/handOverPlan/saveOrUpdate",
    method: "post",
    data
  });
}
/*获取客户订单列表*/
export function planQuerySignOfPage(data) {
  return request({
    url: "/icps/system/sign/basics/plan/QuerySignOfPage",
    method: "post",
    data
  });
}
/*添加客户订单*/
export function handOverPlansaveClientOrder(data) {
  return request({
    url: "/icps/system/sign/intelligent/handOverPlan/saveClientOrder",
    method: "post",
    data
  });
}
/*删除订单*/
export function handOverPlandeleteResord(data) {
  return request({
    url: "/icps/system/sign/intelligent/handOverPlan/deleteResord",
    method: "post",
    data
  });
}
/*获取强度合格评定*/
export function handOverPlanstrength_assessment(params) {
  return request({
    url: "/icps/system/sign/intelligent/handOverPlan/strength_assessment",
    method: "get",
    params
  });
}
/*修改抗压报告值*/
export function update_strength_assessment(data) {
  return request({
    url: "/icps/system/sign/intelligent/handOverPlan/update_strength_assessment",
    method: "post",
    data
  });
}